__turbopack_context__.v({
  "tpSlider": "TrustpilotWidgetSlider-module__OKdYHG__tpSlider",
});
